var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsPayments24SendMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "payments/24/ic_send_money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payments/24/ic_send_money",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.70225,12.21125 C15.30925,12.59925 14.67625,12.59425 14.28825,12.20125 L13.00025,10.89525 L13.00025,16.00025 C13.00025,16.55225 12.55225,17.00025 12.00025,17.00025 C11.44825,17.00025 11.00025,16.55225 11.00025,16.00025 L11.00025,10.89525 L9.71225,12.20125 C9.51625,12.40025 9.25825,12.50025 9.00025,12.50025 C8.74625,12.50025 8.49325,12.40425 8.29825,12.21225 C7.90525,11.82425 7.90025,11.19125 8.28725,10.79825 L11.28625,7.75425 C11.67825,7.35725 12.31925,7.35725 12.71025,7.75425 L15.71225,10.79725 C16.09925,11.19025 16.09525,11.82325 15.70225,12.21125 M21.77325,7.57725 C21.48425,4.75825 19.24225,2.51625 16.42325,2.22725 C13.47425,1.92425 10.52625,1.92425 7.57725,2.22725 C4.75825,2.51625 2.51625,4.75825 2.22725,7.57725 C1.92425,10.52525 1.92425,13.47425 2.22725,16.42225 C2.51625,19.24125 4.75825,21.48325 7.57725,21.77325 C10.52625,22.07525 13.47425,22.07525 16.42325,21.77325 C19.24225,21.48325 21.48425,19.24125 21.77325,16.42225 C22.07625,13.47425 22.07625,10.52525 21.77325,7.57725",
    fill: "#494A4A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPayments24SendMoney);
export default __webpack_public_path__ + "static/media/icons_payments_24_send_money.5814d5a9b20f91edf0e07b1016c83cae.svg";
export { ForwardRef as ReactComponent };